// AUTO-GENERATED GraphQL Builder for MenuCourse
import * as Builders from '../';
export class MenuCourseBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  offeringId(){ return this.add('offeringId'); }
  name(){ return this.add('name'); }
  chooseCount(){ return this.add('chooseCount'); }
  sortOrder(){ return this.add('sortOrder'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  offering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offering'))return this;
    this.v.add('offering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offering { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  courseDishList(b?:(q:Builders.CourseDishBuilder)=>void){
    if(this.depth>=5||this.v.has('courseDishList'))return this;
    this.v.add('courseDishList');
    const n=new Builders.CourseDishBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`courseDishList { ${inner} }`);
    return this;
  }

  reverseCourseDish(b?:(q:Builders.CourseDishBuilder)=>void){
    const n=new Builders.CourseDishBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`courseDishList { ${inner} }`);
    return this;
  }
}
